var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m23.871 7.854-6.831 6.833-.844-.843 5.735-5.82H0V6.84h21.846l-5.65-5.649.843-.843L23.87 7.18c.17.168.17.506 0 .675Z"
})));
export default SvgArrowRight2;